import DirectDebitBecsForm from './direct-debit-becs-form';

export default DirectDebitBecsForm;
